// extracted by mini-css-extract-plugin
export default {"cls1":"SimplePaperPodcast-cls1___9ca235118348b612634","cls2":"SimplePaperPodcast-cls2___912031a6a6a18cf0fb0 SimplePaperPodcast-cls1___9ca235118348b612634"};